<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="isOpen"></div>

<!-- Modal -->
<div class="modal fade show d-block" *ngIf="isOpen" tabindex="-1" role="dialog" style="z-index: 1050;">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div>
          <h4 class="modal-title mb-1">Charge Basis Management</h4>
          <p class="text-muted small mb-0">Define charge units with mode mapping for quotation calculations</p>
        </div>
        <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Statistics Cards -->
        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3">
            <div class="card stat-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <i class="bi bi-list-ul text-primary fs-4 me-2"></i>
                  <div>
                    <p class="text-muted mb-0 small">Total Units</p>
                    <h3 class="mb-0">{{ stats.totalUnits }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="card stat-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <i class="bi bi-airplane text-info fs-4 me-2"></i>
                  <div>
                    <p class="text-muted mb-0 small">Air Units</p>
                    <h3 class="mb-0">{{ stats.airUnits }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="card stat-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <i class="bi bi-water text-primary fs-4 me-2"></i>
                  <div>
                    <p class="text-muted mb-0 small">Sea Units</p>
                    <h3 class="mb-0">{{ stats.seaLclUnits + stats.seaFclUnits }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-3">
            <div class="card stat-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <i class="bi bi-globe text-success fs-4 me-2"></i>
                  <div>
                    <p class="text-muted mb-0 small">Universal</p>
                    <h3 class="mb-0">{{ stats.universalUnits }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Filter Section -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-search"></i></span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search internal name or display name..."
                    [(ngModel)]="searchTerm"
                    (input)="applyFilters()">
                </div>
              </div>
              <div class="col-6 col-md-3">
                <select class="form-select" [(ngModel)]="selectedMode" (change)="applyFilters()">
                  <option value="">All Modes</option>
                  <option value="AIR">Air Freight</option>
                  <option value="SEA_LCL">Sea LCL</option>
                  <option value="SEA_FCL">Sea FCL</option>
                  <option value="UNIVERSAL">Universal (All Modes)</option>
                </select>
              </div>
              <div class="col-6 col-md-3 text-end">
                <button class="btn btn-primary w-100" (click)="openForm()">
                  <i class="bi bi-plus-circle me-1"></i> Add Charge Basis
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Table -->
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Internal Name</th>
                    <th>Display Name</th>
                    <th class="text-center">Air</th>
                    <th class="text-center">Sea LCL</th>
                    <th class="text-center">Sea FCL</th>
                    <th>Notes</th>
                    <th>Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let charge of filteredCharges">
                    <td><code>{{ charge.internalName }}</code></td>
                    <td><strong>{{ charge.displayName }}</strong></td>
                    <td class="text-center">
                      <i class="bi" [class.bi-check-circle-fill]="charge.appliesToAir" [class.text-success]="charge.appliesToAir"
                         [class.bi-x-circle]="!charge.appliesToAir" [class.text-muted]="!charge.appliesToAir"></i>
                    </td>
                    <td class="text-center">
                      <i class="bi" [class.bi-check-circle-fill]="charge.appliesToSeaLcl" [class.text-success]="charge.appliesToSeaLcl"
                         [class.bi-x-circle]="!charge.appliesToSeaLcl" [class.text-muted]="!charge.appliesToSeaLcl"></i>
                    </td>
                    <td class="text-center">
                      <i class="bi" [class.bi-check-circle-fill]="charge.appliesToSeaFcl" [class.text-success]="charge.appliesToSeaFcl"
                         [class.bi-x-circle]="!charge.appliesToSeaFcl" [class.text-muted]="!charge.appliesToSeaFcl"></i>
                    </td>
                    <td><small class="text-muted">{{ charge.notes || '-' }}</small></td>
                    <td>
                      <span class="badge" [class.bg-success]="charge.isActive" [class.bg-secondary]="!charge.isActive">
                        {{ charge.isActive ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-outline-primary me-1" (click)="editCharge(charge)" title="Edit">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="deleteCharge(charge.id)" title="Delete">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="filteredCharges.length === 0">
                    <td colspan="8" class="text-center text-muted py-4">
                      <i class="bi bi-inbox fs-1 d-block mb-2"></i>
                      No charge basis units found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Nested Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showForm"
     style="z-index: 1055 !important; background-color: rgba(0, 0, 0, 0.85) !important;"></div>

<!-- Add/Edit Form Modal (Nested) -->
<div class="modal fade show d-block" *ngIf="showForm" tabindex="-1" role="dialog" style="z-index: 1056 !important;">
  <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Add' }} Charge Basis</h5>
        <button type="button" class="btn-close" (click)="closeForm()"></button>
      </div>
      <div class="modal-body">
        <form>
          <!-- Internal Name -->
          <div class="mb-3">
            <label class="form-label">Internal Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="formData.internalName" name="internalName"
                   placeholder="e.g., per_kg" required>
            <div class="form-text">Use lowercase with underscores (e.g., per_cbm, fixed_amount)</div>
          </div>

          <!-- Display Name -->
          <div class="mb-3">
            <label class="form-label">Display Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="formData.displayName" name="displayName"
                   placeholder="e.g., Per KG" required>
            <div class="form-text">User-friendly name shown in quotations</div>
          </div>

          <!-- Mode Applicability -->
          <div class="mb-3">
            <label class="form-label d-block mb-2">Applies To Modes <span class="text-danger">*</span></label>
            <div class="row">
              <div class="col-4">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.appliesToAir"
                         name="appliesToAir" id="appliesToAir">
                  <label class="form-check-label" for="appliesToAir">
                    <i class="bi bi-airplane me-1"></i> Air Freight
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.appliesToSeaLcl"
                         name="appliesToSeaLcl" id="appliesToSeaLcl">
                  <label class="form-check-label" for="appliesToSeaLcl">
                    <i class="bi bi-box-seam me-1"></i> Sea LCL
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.appliesToSeaFcl"
                         name="appliesToSeaFcl" id="appliesToSeaFcl">
                  <label class="form-check-label" for="appliesToSeaFcl">
                    <i class="bi bi-box me-1"></i> Sea FCL
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label class="form-label">Notes / Use Cases</label>
            <textarea class="form-control" rows="3" [(ngModel)]="formData.notes" name="notes"
              placeholder="Describe when this charge basis is used (e.g., 'Carrier charges, deposit')"></textarea>
          </div>

          <!-- Active Status -->
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="formData.isActive"
                   name="isActive" id="isActive">
            <label class="form-check-label" for="isActive">
              Active (Available for use in quotations)
            </label>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeForm()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCharge()">
          {{ isEditMode ? 'Update' : 'Add' }}
        </button>
      </div>
    </div>
  </div>
</div>
